<template>
  <div class="scan-block">
    <canvas id="canvas" width="250" height="250"></canvas>
    <div class="light-column">
      <img src="./texture/light.png">
    </div>
    <div class="light-wave" id="light-wave">
      <div class="wave" v-for="i in 3" :style="{ '--index': i }"></div>
    </div>
  </div>

</template>
<script setup>
import { onMounted, onUnmounted } from 'vue'
import ImgStage from './img-stage.js'
import ImgSpirit from './img-spirit.js'
import ScanImgSpirit from "./scan-img-spirit.js"
import { PopManager } from './scan-pop.js'
// images
import outer from './texture/outer.png'
import inner from './texture/inner.png'
import inner1 from './texture/inner1.png'
import inner2 from './texture/inner2.png'
import block from './texture/block.png'
import scan from './texture/scan.png'
// import lightImg from './texture/light.png'


function loadImage(importedImg) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = importedImg
    img.onload = () => {
      resolve(img)
    }
    img.onerror = (e) => {
      reject(e)
    }
  })
}

let stage
onMounted(async () => {

  const canvas = document.getElementById('canvas')

  stage = new ImgStage(canvas)

  const [outerImg, innerImg, inner1Img, inner2Img, blockImg, scanImg] = await Promise.all([
    loadImage(outer),
    loadImage(inner),
    loadImage(inner1),
    loadImage(inner2),
    loadImage(block),
    loadImage(scan),
  ])

  let outerSpirit = new ImgSpirit(outerImg)
  let innerSpirit = new ImgSpirit(innerImg, true)
  let inner1Spirit = new ImgSpirit(inner1Img, false, true)
  let inner2Spirit = new ImgSpirit(inner2Img)
  let blockSpirit = new ImgSpirit(blockImg, true)
  let scanSpirit = new ScanImgSpirit(scanImg)
  let pop = new PopManager(canvas)

  stage.add(outerSpirit)
  stage.add(innerSpirit)
  stage.add(inner1Spirit)
  stage.add(inner2Spirit)
  stage.add(blockSpirit)
  stage.add(scanSpirit)
  stage.add(pop)

})


onUnmounted(() => {
  console.log('-->', stage);
  stage.stop()
})



</script>

<style>
.scan-block {
  width: 300px;
  min-height: 330px;
  margin: 16px auto;
  text-align: center;
  height: auto !important;
  position: relative;
}

#canvas {
  /* outline: 1px solid lightgreen; */
}

.light-column {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 24px;
}

.light-wave {
  position: absolute;
  width: 100%;
  aspect-ratio: 1/1;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 142px;
  transform: rotateX(80deg);
  z-index: -1;
}

.wave {
  --gap: 25%;
  --width: calc(var(--index) * var(--gap));

  width: var(--width);
  position: absolute;
  aspect-ratio: 1/1;
  border-radius: 50%;
  background: radial-gradient(transparent 50%, #0088ff 80%, #0088ff);
  animation: wave 1.5s linear infinite;
}

@keyframes wave {
  from {
    width: var(--width);
  }

  to {
    width: calc(var(--width) + var(--gap));
  }
}
</style>
